// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import { EngagementRingLinkFragmentDoc } from './engagementRingLink.fragment.generated';
import { JewelleryLinkFragmentDoc } from './jewelleryLink.fragment.generated';
import { ReadyToGoRingLinkFragmentDoc } from './readyToGoRingLink.fragment.generated';
import { WeddingRingLinkFragmentDoc } from './weddingRingLink.fragment.generated';
export const ProductLinkFragmentDoc = gql`
    fragment productLink on CatalogueProduct {
  __typename
  ...engagementRingLink
  ...jewelleryLink
  ...readyToGoRingLink
  ...weddingRingLink
}
    ${EngagementRingLinkFragmentDoc}
${JewelleryLinkFragmentDoc}
${ReadyToGoRingLinkFragmentDoc}
${WeddingRingLinkFragmentDoc}`;